"use strict";

define('view/file.input',['marionette', 'FileAPI'], function (Mn, FileAPI) {
  var FileInputView = Mn.ItemView.extend({
    tagName: 'input',
    template: false,
    attributes: {
      style: 'display: none;',
      type: 'file'
    },
    triggers: {
      'click': 'press'
    },
    delegateEvents: function delegateEvents() {
      Mn.ItemView.prototype.delegateEvents.apply(this, arguments);
      this._onChangeReference = _.bind(function () {
        var args = _.toArray(arguments);
        this.triggerMethod.apply(this, ['input:change'].concat(args));
      }, this);
      FileAPI.event.on(this.el, 'change', this._onChangeReference);
    },
    undelegateEvents: function undelegateEvents() {
      Mn.ItemView.prototype.undelegateEvents.apply(this, arguments);
      FileAPI.event.off(this.el, 'change', this._onChangeReference);
    },
    onInputChange: function onInputChange(evt) {
      var self = this;
      var asArray = [];
      FileAPI.each(FileAPI.getFiles(evt), function (file) {
        self.triggerMethod('file', file);
        asArray.push(file);
      });
      this.triggerMethod('files', asArray);
      if (_.isFunction(this.getOption('callback'))) {
        this.getOption('callback')(asArray);
      }
    },
    onBeforeRender: function onBeforeRender() {
      var multiple = this.getOption('multiple'),
        accept = this.getOption('accept');
      this.$el.prop('multiple', !!this.getOption('multiple'));
      if (_.isArray(accept)) {
        accept = accept.join(',');
      }
      if (_.isString(accept)) {
        this.$el.attr('accept', accept);
      }
    }
  });
  return FileInputView;
  s;
});

